import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  LinkWrapper,
} from 'athenaeum';

import { trackNavigate } from '../../../utils/analytics';
import styles from './blog_intro.module.scss';

class BlogIntro extends Component {
  render() {
    const {
      intro,
      headerText,
      description,
    } = this.props;

    return (
      <div
        className={styles['blog-intro']}
      >
        <Text
          font="a"
          type={3}
          className={styles.header}
        >
          {headerText}
        </Text>
        <Text
          font="b"
          type={10}
          className={styles.description}
        >
          {description}
        </Text>
        <LinkWrapper
          type="secondary"
          href={intro.link}
          onClick={() => trackNavigate({
            navigate_to: intro.link
          })}
        >
          <Text type={10} font="b">
            View All
          </Text>
        </LinkWrapper>
      </div>
    );
  }
}

BlogIntro.propTypes = {
  intro: PropTypes.shape({
    textType: PropTypes.string,
    link: PropTypes.string,
  }),
  headerText: PropTypes.string,
  description: PropTypes.string,
};

export default BlogIntro;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Submenu/Intro/Blog/index.js